/**
 * L'account di consultazione vede il gestionale ma non può modificarlo:
 * i comandi di scrittura vanno nascosti, non solo respinti dal server.
 */
export const isSolaLettura = (utente) => utente?.ruolo === 'SOLA_LETTURA';

export const puoModificare = (utente) => !isSolaLettura(utente);
